const FILTERS_STORAGE_KEY = 'customEventPreviousFilters';
const FILTERS_TIMESTAMP_KEY = 'customEventPreviousFiltersTimestamp';
const THIRTY_MINUTES_MS = 30 * 60 * 1000;

let previousFilters = {};

// Load filters from localStorage if available and not expired
const storedFilters = localStorage.getItem(FILTERS_STORAGE_KEY);
const storedTimestamp = localStorage.getItem(FILTERS_TIMESTAMP_KEY);

if (storedFilters && storedTimestamp) {
    const timestamp = parseInt(storedTimestamp, 10);
    if (Date.now() - timestamp < THIRTY_MINUTES_MS) {
        try {
            previousFilters = JSON.parse(storedFilters);
        } catch (e) {
            console.error('Error parsing stored filters:', e);
            previousFilters = {}; // Reset if parsing fails
        }
    } else {
        // Clear expired filters from storage
        localStorage.removeItem(FILTERS_STORAGE_KEY);
        localStorage.removeItem(FILTERS_TIMESTAMP_KEY);
    }
}

document.addEventListener('facet:update', (event) => {
    const currentUrl = new URL(window.location.href);
    const currentFilters = {};
    currentUrl.searchParams.forEach((value, key) => {
        if (key.startsWith('filter.')) {
            currentFilters[key] = value.split(',');
        }
    });

    const newFilters = {};
    for (const key in currentFilters) {
        if (currentFilters.hasOwnProperty(key)) {
            // Ensure previousFilters[key] is an array before calling .includes()
            const previousValues = previousFilters[key] || [];
            const newValues = currentFilters[key].filter((value) => !previousValues.includes(value));
            if (newValues.length > 0) {
                newFilters[key] = newValues;
            }
        }
    }

    if (Object.keys(newFilters).length > 0) {
        Object.entries(newFilters).forEach(([filter_type, values]) => {
            values.forEach((value) => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'filter_selected',
                    filter_type,
                    filter_value: value
                });
            });
        });
    }

    // Update previousFilters with a shallow copy of currentFilters
    // This is safe because currentFilters and its arrays are regenerated in each event
    previousFilters = { ...currentFilters };

    // Save updated filters and current timestamp to localStorage
    try {
        localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(previousFilters));
        localStorage.setItem(FILTERS_TIMESTAMP_KEY, Date.now().toString());
    } catch (e) {
        console.error('Error saving filters to localStorage:', e);
    }
});
